import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

const initialState = {
  reports: {},
  loading: false,
  error: null,
  pagination: {},
  selectedReport: null
};

/* ================== THUNKS ================== */

export const fetchContentReports = createAsyncThunk(
  'content-reports/fetch',
  async ({ fetchType = "table", page = 1, limit = 10, search = '' }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/api/admin/content-reports', {
        params: { fetchType, page, limit, search }
      });
      return {
        data: response.data?.data?.records || [],
        pagination: response.data?.data?.pagination || {},
      };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const fetchContentReportById = createAsyncThunk(
  'content-reports/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/admin/content-reports/${id}`);
      console.log('response', response.data.data)
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);


/* ================== SLICE ================== */

const contentReportSlice = createSlice({
  name: 'content-reports',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      /* FETCH */
      .addCase(fetchContentReports.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchContentReports.fulfilled, (state, action) => {
        const { data, pagination } = action.payload;
        state.loading = false;
        state.pagination = pagination;
        state.reports = data;
      })
      .addCase(fetchContentReports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchContentReportById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedReport = action.payload;
      })
      .addCase(fetchContentReportById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default contentReportSlice.reducer;